import { css } from '@/styled-system/css';
import { token } from '@/styled-system/tokens';

const MOBILE_HEADER_HEIGHT = token('sizes.1200');

export const detailHubContainer = css({
  display: 'flex',
  flexDirection: 'column',
  backgroundColor: 'bg.neutral',
  position: 'relative',
  minHeight: '100vh',
  '@supports (min-height: 100dvh)': {
    minHeight: '100dvh',
  },
  lg: {
    minHeight: 'unset',
  },
});

export const detailHeader = css({
  position: 'fixed',
  top: 0,
  left: 0,
  width: '100%',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  paddingInline: 'default',
  paddingBlock: 'default',
  minHeight: MOBILE_HEADER_HEIGHT,
  backgroundColor: 'transparent',
  zIndex: 'zIndexOverParent',
  lg: {
    display: 'none',
  },
});

export const headerActions = css({
  display: 'flex',
  gap: 'default',
  alignItems: 'center',
});

export const detailMainContent = css({
  flex: 1,
  position: 'relative',
  lg: {
    display: 'flex',
    flexDirection: 'column',
  },
});

// Body surface for the route-native HDP. Document scroll owns the page; the
// desktop map stays sticky beside it in the shared search shell.
export const detailScrollArea = css({
  lg: {
    scrollbarGutter: 'stable',
  },
});

export const detailBody = css({
  width: '100%',
});

export const detailFooter = css({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  minHeight: '1800',
  position: 'sticky',
  bottom: 0,
  zIndex: 'zIndexStep',
  lg: {
    display: 'none',
  },
});

export const spokeFooterActions = css({
  display: 'flex',
  gap: 'tighter',
  width: '100%',
  marginInline: 'auto',
  // eslint-disable-next-line hotpads/no-magic-numbers -- caps sticky footer CTAs to the designed mobile button group width
  maxWidth: '400px',
});

export const desktopFloatingFooter = css({
  display: 'none',
  lg: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    position: 'fixed',
    right: 'calc({spacing.default} + var(--floating-ui-scrollbar-width))',
    bottom: 'loose',
    width: '100cqi',
    pointerEvents: 'none',
    zIndex: 'zIndexOverParent',
    _before: {
      backgroundColor: 'bg.neutral',
      bottom: 'calc(-1 * {spacing.loose})',
      content: '""',
      left: 0,
      pointerEvents: 'auto',
      position: 'absolute',
      right: 0,
      top: '100%',
    },
  },
});

export const floatingFooterSurface = css({
  width: '100%',
  padding: 'default',
  pointerEvents: 'auto',
  lg: {
    width: 'calc(100% - {spacing.default} - {spacing.default})',
  },
});

export const desktopFooterActions = css({
  display: 'flex',
  gap: 'tighter',
  width: '100%',
});
